module.exports = __webpack_public_path__ + "static/media/fundo.fce9f7c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fundo.png
// module id = 46
// module chunks = 0